import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'

const InvoicePaste = Loadable(lazy(() => import('./InvoicePaste')))

const PasteInvoiceRoutes = [
    {
        path: '/upload-invoice',
        element: <InvoicePaste />,
        auth: authRoles.admin,
    },
]

export default PasteInvoiceRoutes
